/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param model
 * @param setModel
 * @returns {{handleChange: (function(*=, *=, *=, *=): void)}}
 * @constructor
 */
const HandleChange = ({ model, setModel }) => {

    const handleChange = (evt, name = '', child = '', subChild = '') => {

        let value;

        if (!evt) {
            value = evt;
        } else {
            value = evt.target.value;

            if (evt?.target?.type === 'checkbox') {
                value = evt.target.checked;
            }

            if (evt?.target?.type === 'radio') {
                value = value === 'true' || value === true;
            }
        }

        // 🔥 soporte path (nuevo)
        if (Array.isArray(name)) {
            const path = name;

            setModel(prev => {
                const newState = { ...prev };
                let current = newState;

                for (let i = 0; i < path.length - 1; i++) {
                    const key = path[i];

                    current[key] = Array.isArray(current[key])
                        ? [...current[key]]
                        : { ...current[key] };

                    current = current[key];
                }

                current[path[path.length - 1]] = value;

                return newState;
            });

            return;
        }

        if (!name || typeof name === 'object') {
            name = evt?.target?.name;
        }

        if (child && typeof subChild === "number") {
            setModel(prev => ({
                ...prev,
                [child]: prev[child].map((item, i) =>
                    i === subChild ? { ...item, [name]: value } : item
                )
            }));
            return;
        }

        if (child && !subChild) {
            setModel(prev => ({
                ...prev,
                [child]: {
                    ...prev[child],
                    [name]: value,
                },
            }));
            return;
        }

        if (child && subChild) {
            setModel(prev => ({
                ...prev,
                [child]: {
                    ...prev[child],
                    [subChild]: {
                        ...prev[child][subChild],
                        [name]: value,
                    },
                },
            }));
            return;
        }

        // fallback legacy
        setModel(prev => ({
            ...prev,
            [name]: value
        }));
    };

    return { handleChange };
};
export default HandleChange;
